import axios from 'axios';

export const getSettings = async () => {
    const response = await axios.get('/settings.json');
    return response.data;
};